 /*-----------------------------------------------------------------------------------
    Main
    Author: Rodrigo Bouza
    ---------------------------------- */

;(function(w) {
    function Main() {
        // Loader
        $('body').removeClass('loading');

        var ua = navigator.userAgent.toLowerCase(); 
        var browser_nav;

        if (ua.indexOf('safari') != -1) { 
            if (ua.indexOf('chrome') > -1) {
                browser_nav = 'chrome'; // Chrome
                $('body').addClass('chrome');
            } else {
                browser_nav = 'safari'; // Safari
                $('body').addClass('safari');
            }
        }

        // Mac detect
        var mac = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
        if (mac) {
            $('body').addClass('mac');
        }

        // iOS Detect
        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        if (iOS) {
            $('body').addClass('ios');
        }

        // Play sound video
        $('#video_sound_holder').click(function(e) {
            e.preventDefault();

            var video = $('#video_sound_freq');
            var video_holder = $(this);
            video_holder.toggleClass('video-inline--playing');

            if (video_holder.hasClass('video-inline--playing')) {
                video.get(0).play();
            } else {
                video.get(0).pause();
            }
            
        });

        // On video end show again the play btn
        /*$('#video_sound_freq').on('ended', function() {
            var video_holder = $('#video_sound_holder');
            video_holder.removeClass('video-inline--playing');
        });*/

        // Wow
        var wow = new WOW({
            offset: 50,
            mobile: false,
        });
        
        wow.init();

        // Scroll init
         setTimeout(function () {
             $('html').scrollTop(0);
         }, 50);
        
        // Menu navigation 
        $('#navigation a').click(function(e) {
            e.preventDefault();

            var section = $($(this).attr('href'));

            //$('#navigation a').removeClass('navigation__link--active');
            //$(this).addClass('navigation__link--active');

            if($(window).width() < 992 && $('body').hasClass('menu-active')) {
                $('body').removeClass('menu-active');

                setTimeout(function() {
                    scrollToElement(section, 850, 0);
                }, 700);
            } else {
                scrollToElement(section, 850, 0);
            }
        });

        // Scroll to element
        $('.js-scroll-to').click(function (e) {
            e.preventDefault();

            var element = ($(this).data('scroll')) ? $($(this).data('scroll')) : $($(this).attr('href'));

            scrollToElement(element, 850, 0);
        });

        // Video overlay close
        $('#video_overlay .video-overlay__close').click(function(e) {
            e.preventDefault();

            var video_overlay_el = $('#video_overlay');
            var video_iframe = video_overlay_el.find('iframe');
            video_overlay_el.removeClass('video-overlay--anim');

            setTimeout(function() {
                video_overlay_el.removeClass('video-overlay--show');
                video_overlay_el.removeClass('video-overlay--local');
                video_iframe.prop('src', '');
            }, 500);
        });

        // Btn play Showcase
        $('.js-btn-play-video').click(function(e) {
            e.preventDefault();

            var video_url = $(this).data('video-url');
            var video_local = $(this).data('video-local');
            var video_overlay_el = $('#video_overlay');
            var video_iframe = video_overlay_el.find('iframe');

            if (video_local) {
                video_overlay_el.addClass('video-overlay--local');
            }

            video_iframe.prop('src', video_url);
            
            video_overlay_el.addClass('video-overlay--show');

            setTimeout(function() {
                video_overlay_el.addClass('video-overlay--anim');
            }, 800);
        });

        // Image popup - Btn more
        $('.js-img-popup .img-popup__bt-more').click(function(e) {
            e.preventDefault();

            var img_popup = $(this).closest('.img-popup');
            img_popup.addClass('img-popup--active');

            if (img_popup.hasClass('img-popup--active')) {
                var active_item = $('.img-popup-content--active');

                $('.img-popup-content--active').fadeOut(function () {
                    active_item.removeClass('img-popup-content--active');
                    
                    $(this).next().fadeIn(function() {
                        $(this).addClass('img-popup-content--active');
                    });
                });
            }
        });

        // Image popup - Btn close
        $('.js-img-popup .img-popup__bt-close').click(function(e) {
            e.preventDefault();

            var img_popup = $(this).closest('.img-popup');
            img_popup.removeClass('img-popup--active');

            if (!img_popup.hasClass('img-popup--active')) {
                var active_item = $('.img-popup-content--active');

                $('.img-popup-content--active').fadeOut(function () {
                    active_item.removeClass('img-popup-content--active');
                    
                    $(this).prev().fadeIn(function() {
                        $(this).addClass('img-popup-content--active');
                    });
                });
            }
        });

        // Slider testimonials
        var slider_testimonials = tns({
            container: '#slider_testimonials',
            //slideBy: 'page',
            nav: false,
            controls: false,
            autoWidth: false,
            mouseDrag: false,
            edgePadding: 60,
            mouseDrag: true,
            touch: true,
            loop: false,
            gutter: 0,
            speed: 750,
            items: 1,
            preventActionWhenRunning: true,
            responsive: {
                320: {
                    edgePadding: 50,
                },
                992: {
                    items: 3,
                    edgePadding: 0,
                    gutter: 60,
                },
                1200: {
                    items: 4
                },
                1600: {
                    items: 5
                }
            }
        });

        slider_testimonials.events.on('indexChanged', function(info) {
            $('#slider_testimonials .tns-item').removeClass('tns-current');
            $('#slider_testimonials .tns-item:nth-of-type(' + info.displayIndex + ')').addClass('tns-current');
       });     

        // Slider Testimonials nav controls
        $('.slider--testimonials .slider-nav__control').click(function(e) {
            e.preventDefault();

            var goto = $(this).data('goto');
            slider_testimonials.goTo(goto);
        });

        // Btn menu mobile
        $('#btn_menu_mobile').click(function(e) {
            e.preventDefault();

            $('body').toggleClass('menu-active');

        });

        // Scroll To Element
        function scrollToElement(el, speed, offset) {
            offset = typeof offset !== 'undefined' ? offset : 0;

            $([document.documentElement, document.body]).animate({
                scrollTop: el.offset().top - offset
            }, speed, 'easeInOutCirc');
        };

        // On scroll
        $(window).scroll(function(e) {
            var scroll = $(window).scrollTop();
            var header = $('#header');
            var video_sound = $('#video_sound_holder');
            var video_sound_element = $('#video_sound_freq');

            // Show/Hide Btn circle sound fixed
            if (scroll > ($('#section_testimonials').offset().top-$('#section_testimonials').height()) && !$('#btn_freq').hasClass('btn-circle-icon--hide')) {
                $('#btn_freq').addClass('btn-circle-icon--hide');
            } else if (scroll < ($('#section_testimonials').offset().top-$('#section_testimonials').height()) && $('#btn_freq').hasClass('btn-circle-icon--hide')) {
                $('#btn_freq').removeClass('btn-circle-icon--hide');
            }

            if (video_sound.hasClass('video-inline--playing') &&
                (scroll > ($('#section_sound').offset().top + $('#section_sound').height() / 2) || 
                scroll < ($('#section_sound').offset().top - $('#section_sound').height() / 2))
               ) {
                video_sound.removeClass('video-inline--playing');
                video_sound_element.get(0).pause();
                video_sound_element.currentTime = 0;
               }
            
            // Only Desktop
            if ($(window).width() > 991) {
                // Scroll nav active change
                $('#navigation .navigation__link').each(function(e) {
                    var currLink = $(this);
                    var refElement = $(currLink.attr("href"));

                    //console.log(currLink.attr("href"));

                    if ((refElement.position().top - refElement.height() / 1.5) <= scroll && (refElement.position().top + refElement.height() / 1.5) > scroll) {
                        $('.navigation__link').removeClass("navigation__link--active");
                        currLink.addClass("navigation__link--active");
                    } else{
                        currLink.removeClass("navigation__link--active");
                    }
                });

                // Header Logos color
                $('.section').each(function() {
                    var data_nav_color = $(this).data('nav-color') ? $(this).data('nav-color') : 'black';

                    if (scroll >= $(this).offset().top &&
                        scroll < ($(this).offset().top + $(this).height()) &&
                        !header.hasClass('header--white') &&
                        data_nav_color === 'white') {
                            header.addClass('header--white');
                    } else if (scroll >= $(this).offset().top &&
                               scroll < ($(this).offset().top + $(this).height()) &&
                               header.hasClass('header--white') &&
                               data_nav_color === 'black') {
                        header.removeClass('header--white');
                    }
                });
            }
        });
    }

    w.Main = Main;
})(window)